import { buildApiUrl } from '../config';
import useAPI from '../../hooks/useAPI';
import { FortnoxImportRun } from '../../models/FortnoxImportRun';

/** Continues an import that did not finish, from where it stopped. */
export const useResumeFortnoxImport = () => {
  const { callAPI } = useAPI<FortnoxImportRun>({ method: 'POST' });

  const action = async (runId: string): Promise<FortnoxImportRun> =>
    (await callAPI(buildApiUrl(`fortnoxImport/${runId}/resume`))) as FortnoxImportRun;

  return { action };
};
